import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { tryToFetchSingleGuest2 } from '../../../store/brokers/partner/guests/guestsSlice';
import GuestInfoTab from './details/GuestInfoTab';
import { useGetGuestDetailsInfoMutation } from '../../../store/reservations/reservationsApi';
import ReservationHistory from './details/ReservationHistory';
import { LoadingMessages } from '../../../utils/constants/guest-messages';

const tabs = [
	{ label: 'Guest Info', value: 'info' },
	{ label: 'Booking History', value: 'history' },
]

const GuestDetails2 = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const [activeTab, setActiveTab] = useState<any>(tabs[0]);
	const [loadingText, setLoadingText] = useState(LoadingMessages[0]);
	const [getGuestDetailsInfo, { isLoading }] = useGetGuestDetailsInfoMutation();
	const details = useAppSelector((state) => state?.guests?.guestDetails);

	console.log({details})

	const onGoBack = () => {
		navigate(-1)
	}

	useEffect(() => {
		if (!isLoading) {
			setLoadingText(LoadingMessages[0]);
			return;
		}
		let index = 0;
		const interval = setInterval(() => {
			index = (index + 1) % LoadingMessages.length;
			setLoadingText(LoadingMessages[index]);
		}, 5000);

		return () => clearInterval(interval);
	}, [isLoading]);

	useEffect(() => {
		if (id) {
			dispatch(tryToFetchSingleGuest2(id));
		}
	}, [id]);

	const onChangeActiveTab = (tab: any) => {
		setActiveTab(tab)
	}

	return (
		<div>
			<div className={'flex flex-row items-center justify-between'}>
				<div className='flex flex-row items-center'>
					<div data-qa={'back-button'} onClick={onGoBack} className='md:-ml-2 xl:-ml-5 md:mr-2 xl:mr-4'>
						<img src={'/assets/shared/go-back-new.svg'} className={'w-[35px] object-contain cursor-pointer'} />
					</div>
					<p className='text-primary-light text-sm font-medium'>Guests &gt; Guest Intelligence Information</p>
				</div>
			</div>
			<div className='flex flex-col md:flex-row md:justify-between my-5'>
				<div className='flex flex-row items-center'>
					{tabs?.map((item: any, idx: number) => {
						return (
							<div
								key={idx}
								onClick={() => onChangeActiveTab(item)}
								className={`${activeTab?.value === item?.value ? 'border-b border-b-[#00330F] pb-2' : '!pb-3'}  pt-y px-4 cursor-pointer hover:opacity-90`}>
								<p className={`${activeTab?.value === item?.value ? 'text-primary-default' : 'text-primary-light'}`}>{item?.label}</p>
							</div>
						)
					})}
				</div>
			</div>
			{activeTab?.value === 'info' ?
							<GuestInfoTab
								data={details}
								id={id || ''}
							/>
							: <ReservationHistory
								id={id || ''}
							/>
						}
		</div>
	)
}
export default GuestDetails2;